// extracted by mini-css-extract-plugin
export default {"divider":"divider__pZtU5w","dangerZone":"dangerZone__QXZYRr"};